import {defineComponent} from 'vue'
import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw} from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import("@/layout/index.vue"),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import("@/layout/index.vue"),
    children: [
      {
        path: '/index',
        name: 'index',
        meta: {cache: true},
        component: () => import("@/views/index.vue"),
      },
      {
        path: '/iot/:id',
        name: 'iot',
        component: () => import("@/views/iot/index.vue"),
      },
      {
        path: '/iot/detail/:id',
        name: 'iotDetail',
        component: () => import("@/views/iot/iotDetail.vue"),
      },
      {
        path: '/solutions',
        name: 'solutions',
        component: () => import("@/views/solutions/index.vue"),
      },
      {
        path: '/solutions/detail/:id',
        name: 'solutionsDetail',
        component: () => import("@/views/solutions/solutionsDetailNew.vue"),
      },
      {
        path: '/software',
        name: 'software',
        component: () => import("@/views/software/index.vue"),
      },
      {
        path: '/software/detail/:id',
        name: 'softwareDetail',
        component: () => import("@/views/software/softwareDetail.vue"),
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import("@/views/aboutUs/index.vue"),
      },
      {
        path: '/aboutUs/recruit',
        name: 'aboutUsRecruit',
        component: () => import("@/views/aboutUs/recruit.vue"),
      },
      {
        path: '/news',
        name: 'news',
        component: () => import("@/views/news/index.vue"),
      },
      {
        path: '/news/detail/:id',
        name: 'newsDetail',
        component: () => import("@/views/news/newsDetail.vue"),
      },
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import("@/views/test.vue")
  },
]

const useRouter = createRouter({
  history: createWebHistory(process.env.NODE_ENV === "production" ? "/website/" : "/"), // 修改为历史模式
  routes
})
useRouter.afterEach((to, from, next) => {
  window.scrollTo(0, 0);//回到顶部
});
export default useRouter

